import { useQueryClient } from "@tanstack/react-query";

import useVehiclesMutations from "../../data/useVehiclesMutations";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { IVehicle } from "../../models/Vehicle";
import { UserIcon } from "@heroicons/react/24/solid";
import { ExportSource, ExportType } from "../../models/ExportOffer";
import { useEffect, useState } from "react";

export default function AwaitingInventoryVfePrice({ vehicle, leadId = null, setAssignExporter }: { vehicle: IVehicle, leadId?: string | null, setAssignExporter?: any }) {
  const queryClient = useQueryClient();
  const { update } = useVehiclesMutations();
  const { saveHandlers } = useDefaultCRUDHandlers("Engine Export Price");

  const [accepted, setAccepted] = useState<boolean>(false);

  useEffect(() => {
    if (vehicle.exportOffers) {
      setAccepted(vehicle.exportOffers.some((o) => o.type === ExportType.FrontEnd && o.isAccepted));
    }
  }, [vehicle.exportOffers])

  const handlePriceUpdate = (price: string) => {

    const updatedVehicle: IVehicle = {
      ...vehicle!,
      enginesWorldwideVfeOffer: price,
    };

    update.mutate(updatedVehicle, {
      onSuccess: () => {
        saveHandlers.onSuccess();

        setTimeout(() => {
          leadId ? queryClient.refetchQueries(["lead", leadId]) :
            queryClient.refetchQueries(["leads"]);
        }, 200);
      },
      onError: (error) => {
        saveHandlers.onError();
      }
    });
  }

  return (
    <div className="w-full h-full flex items-center" onClick={(e) => e.stopPropagation()}>
      £ <input
        key={vehicle.id}
        defaultValue={parseFloat(vehicle!.enginesWorldwideVfeOffer!).toFixed(2)}
        className="h-8 w-full border p-1 ml-2 text-sm" type="number"
        onBlur={(e) => handlePriceUpdate(e.target.value)}
      />
      {!accepted && setAssignExporter && (
        <UserIcon className="h-6 w-6 text-gray-400 ml-1 hover:text-primary hover:scale-110 transition-all duration-200"
          onClick={() => setAssignExporter({
            price: 0,
            userId: null,
          
            source: ExportSource.Other,
            type: ExportType.FrontEnd,
          
            vehicleId: vehicle.id,
            isAccepted: true,
          })} 
        />
      )}
    </div>
  )
}
